import { useDispatch, useSelector } from 'react-redux';

// Types
import { AppDispatch } from 'types/RootState.types';
import { CardholdersDetailsAddressBookProps } from './CardholdersDetailsAddressBook.types';

// Config
import cardholdersDetailsAddressBookState from './CardholdersDetailsAddressBook.state';
import { activeAddressBookModals } from '@constants/addressBookModalConstants';
import routeConstants from '@constants/routeConstants';
import { updateAddress } from '@redux/actions/addressBook/addressBookActions';
import { showBillingAddressBookModal } from '@redux/actions/payment/paymentActions';
import { getCountryNameFromCode } from '@utils/address/internationalAddress';
import getBillingDetailsFormConfig, { BILLING_ADDRESS_FORM_ID } from '@utils/form/configs/billingAddress';

// Components
import AddressBookModal from '@components/address-book-modal';
import Container from '@components/container';
import DisplayAddress from '@components/display-address/DisplayAddress';
import InvalidAddressForm from '@components/invalid-address-form/InvalidAddressForm';

const CardholdersDetailsAddressBook = ({ showChangeAddressButton = false }: CardholdersDetailsAddressBookProps) => {
  const dispatch: AppDispatch = useDispatch();
  const {
    activeAddressBookModal,
    addressBook = [],
    billingAddress = {},
    showAddressBookModal,
    singlePageCheckoutEnabled,
  } = useSelector(cardholdersDetailsAddressBookState);

  let shouldShowAddressBookModal = showAddressBookModal;
  if (singlePageCheckoutEnabled) {
    shouldShowAddressBookModal = activeAddressBookModal === activeAddressBookModals.BILLING;
  }

  const { address: { countryCode = '' } = {} } = billingAddress;
  const transformedAddress =
    countryCode && countryCode !== 'GB'
      ? {
          ...billingAddress.address,
          countryCode: getCountryNameFromCode(countryCode),
        }
      : billingAddress.address;

  const onChangeAddress = () => dispatch(showBillingAddressBookModal());
  const onUpdateAddress = ({ formId, formValues, handleModalClose }: any) =>
    dispatch(
      updateAddress({
        formId,
        formValues,
        handleModalClose,
      }),
    );
  const getConfig = getBillingDetailsFormConfig;

  return (
    <>
      {!billingAddress.invalid && (
        <>
          <Container marginBottom="2" marginRight="1">
            <DisplayAddress
              address={transformedAddress}
              addressee={billingAddress.addressee}
              data-testid="payment-card-billing-address"
              inline
              phoneNumber={billingAddress.phoneNumber}
            />
          </Container>
        </>
      )}

      {billingAddress.invalid && !showAddressBookModal && (
        <InvalidAddressForm
          addressBook={addressBook}
          addressFormId={BILLING_ADDRESS_FORM_ID}
          getConfig={getConfig}
          international
          isBillingAddress
          messageBody="Some of the information in your saved billing address is missing or invalid. Please update this information or change the address to continue."
          onChangeAddress={onChangeAddress}
          onUpdateAddress={onUpdateAddress}
          savedAddress={billingAddress}
          showChangeAddressButton={showChangeAddressButton}
        />
      )}

      {shouldShowAddressBookModal && (
        <AddressBookModal
          baseRoutePath={singlePageCheckoutEnabled ? routeConstants.SECURE : routeConstants.PAYMENT}
          formId={BILLING_ADDRESS_FORM_ID}
          getConfig={getConfig}
          international
        />
      )}
    </>
  );
};

export default CardholdersDetailsAddressBook;
